import type { ReactElement } from 'react';

interface ShapeDrawingBlockedNoticeProps {
  /** 지금 그릴 수 없는 사유. */
  readonly reason: string;
  readonly onCancel: () => void;
}

/** 그리기 대상은 있지만 캔버스에서 그릴 수 없을 때의 안내. 운영자가 그리기를 그만둘 수 있게 취소 버튼을 둔다. */
export const ShapeDrawingBlockedNotice = ({
  reason,
  onCancel,
}: ShapeDrawingBlockedNoticeProps): ReactElement => (
  <div className="flex flex-wrap items-center gap-2 text-sm">
    <p role="status" className="text-muted-foreground">
      {reason}
    </p>
    <button type="button" className="rounded border px-2 py-1" onClick={onCancel}>
      그리기 취소
    </button>
  </div>
);
